<template>
  <div class="full-m-table-body">
    <table border="0" cellspacing="0">
      <tbody>
        <tr>
          <th>班级</th>
          <th>学生数</th>
          <th>离寝</th>
          <th>在寝</th>
        </tr>
        <tr>
          <th>一年级1班</th>
          <td>80</td>
          <td>22</td>
          <td>58</td>
        </tr>
        <tr>
          <th>一年级1班</th>
          <td>74</td>
          <td>22</td>
          <td>52</td>
        </tr>
        <tr>
          <th>一年级1班</th>
          <td>65</td>
          <td>50</td>
          <td>15</td>
        </tr>
        <tr>
          <th>一年级1班</th>
          <td>81</td>
          <td>10</td>
          <td>71</td>
        </tr>
        <tr>
          <th>一年级1班</th>
          <td>81</td>
          <td>10</td>
          <td>71</td>
        </tr>
        <tr>
          <th>一年级1班</th>
          <td>81</td>
          <td>10</td>
          <td>71</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.full-m-table-body {
  padding: 20px 15px 15px 15px;
  height: 100%;
  overflow: hidden;
  table {
    width: 100%;
    text-align: center;
    color: #fff;
    th,
    td {
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      padding: 9px 0;
      font-size: 16px;
    }
    th {
      background: rgba(0, 0, 0, 0.1);
    }
    td {
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .full-m-num-item {
    width: 50%;
    float: left;
    padding-right: 15px;
    padding-bottom: 20px;
    p {
      background-color: rgba(15, 31, 56, 0.5);
      margin: 0;
      color: #fff;
      box-shadow: 0 0 5px #2c58a6;
      border-radius: 5px;
      span {
        font-size: 20px;
        display: block;
        text-align: center;
      }
      i {
        font-size: 20px;
        display: block;
        text-align: center;
        font-style: normal;
        em {
          font-style: normal;
          padding-left: 3px;
        }
      }
    }
  }
}
</style>
